export function Builder() {
    return <div>
        Graphic Builder
    </div>
}